import { IntercomDataDto, MemberDto } from "../generated/dashboard-client";
import { formatPrice, getCookieValue } from "../util/utils";
import { Intercom, show, update } from "@intercom/messenger-js-sdk";
import { toastReps } from "../util/constants";
import DSAApi from "../api/DSAApi";

const INTERCOM_APP_ID = "zholilul";

export const ChatService = {
  init(member: MemberDto) {
    console.log(">>> starting chat with member: ", member);

    // Intercom
    Intercom({
      app_id: INTERCOM_APP_ID,
      user_id: member.internalId?.toString() ?? member.id,
      email: member.email,
      name: member.name,
      created_at: new Date(member.createdDate!).getTime() / 1000,
      team_owner_id: member.ownerId,
      team_id: member.teamId,
      server: getCookieValue("SRVID"),
      utm_source: getCookieValue("utm_source"),
      utm_medium: getCookieValue("utm_medium"),
      utm_campaign: getCookieValue("utm_campaign"),
      status: getStatus(member),
      account_created: new Date(member.createdDate!).toString(),
      account_role: member.role,
    });
  },

  newMessage() {
    show();
  },

  async addMemberDetails(data: IntercomDataDto) {
    if (!data) return;

    console.log(">>> sending more member details to Intercom: ", data);

    let dd_url = "";
    
    const dd_user = (window as any)['DD_RUM']?.getUser();

    if (dd_user.email) {
      const applicationId = (window as any)['DD_RUM'].getInitConfiguration()?.applicationId
      const now = Date.now();
      const email = encodeURIComponent(dd_user.email);
      const twoWeeksAgo = now - (14 * 24 * 60 * 60 * 1000); // 14 days in milliseconds
      dd_url = `https://app.datadoghq.com/rum/sessions?query=%40type%3Asession%20%40application.id%3A${applicationId}%20%40usr.email%3A%22${email}%22&agg_m=count&agg_m_source=base&agg_t=count&cols=&fromUser=false&sort_by=time&sort_order=desc&viz=stream&from_ts=${twoWeeksAgo}&to_ts=${now}&live=true`
    }
    console.log(">>> dd_url: ", dd_url);

    let toastRep = '';
    if (data.zip) {
      for (let i = 0; i < toastReps.length; i++) {
        const rep = toastReps[i];
        if (rep.zipCodes.includes(parseInt(data.zip))) {
          toastRep = rep.name;
          break;
        }
      }
    }
    console.log(">>> toast rep: " + toastRep);

    const screens = await DSAApi.getScreens();
    const availableDevices = await DSAApi.getScreensTotal();
    const deactivatedDevices = await DSAApi.getDeactivatedScreensTotal();
    const totalScreensAndLicenses = screens.data.length + availableDevices.data + deactivatedDevices.data;
    const isDisplay = totalScreensAndLicenses > 0;
    console.log(">>> is display: " + isDisplay);

    // Intercom
    update({
      customer_level: data.customerLevel,
      has_abandoned_cart: data.hasAbandonedCart === 'true',
      has_ds_project: data.hasDsProject === 'true',
      last_order_date: data.lastOrderDate,
      last_print_order: data.lastPrintOrder,
      plan_id: data.renewing === 'true' ? data.planId : "",
      plan_name: getPlanName(data.renewing === 'true' ? data.planId : ""),
      addon_products: data.addonProducts,
      renewal_rate: formatPrice(data.renewalRate || 0),
      renewal_date: getRenewalDateFormatted(data.renewalDate),
      pos: data.pos,
      businessName: data.businessName,
      dd_url: dd_url,
      zipcode: data.zip,
      toast_rep: toastRep,
      is_display: isDisplay,
    });
  },
};

function getPlanName(planId: string | undefined) {
  if (planId === '1059') return 'Annual Plan';
  if (planId === '1060') return 'Monthly Plan';
  return 'Free Plan';
}

function getStatus(member: MemberDto) {
  switch (member.status) {
    case 1: return "Active Premium";
    case 5: return "Active Free";
    case 2: return "On Hold";
    case 3: return "Cancelled";
    case 4: return "Declined";
    case 6: return "Paused";
    case 7: return "Past due";
    case 8: return "Removed";
    case -1: return "Any";
    default: return null;
  }
}

function getRenewalDateFormatted(date: string | undefined) {
  if (!date) return undefined;
  return new Date(date).toLocaleDateString('en-US');
}

